import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {BestellvorschlagArtikelDetail} from '../data/bestellvorschlag-artikel-detail';

export const BestellvorschlagArtikelDetailStore =
  new StoreBuilder(RemoteCollectionStore.create<BestellvorschlagArtikelDetail>())
    .value
